<div class="page-content-container">
  <div class="header-container">
    <!-- Layout reorganizado para melhor uso do espaço -->
    <div class="header-actions">
      @if (selectedTabIndex === 0) {
        <!-- Layout condicional baseado no tipo de usuário -->
        @if (userService.isGeoambiente) {
          <!-- Admin: Filtros e busca na primeira linha -->
          <div class="filters-row">
            <app-monitoring-filter-modal
              (filterChange)="handleModalFilterChange($event)"
            ></app-monitoring-filter-modal>

            <app-datasafra-search
              (search)="handleSearch($event)"
            ></app-datasafra-search>
          </div>

          <!-- Admin: Botões de ação na segunda linha -->
          <div class="actions-row">
            <button
              mat-flat-button
              extended
              (click)="generateSeedFile()"
              [disabled]="
                ((buttonLoading$ | async) ?? false) ||
                ((globalLoading$ | async) ?? false) ||
                ((gridLoading$ | async) ?? false) ||
                !canGenerateSeedFile
              "
            >
              @if ((buttonLoading$ | async) ?? false) {
                <mat-icon>hourglass_empty</mat-icon>
              } @else {
                <mat-icon>file_download</mat-icon>
              }
              Gerar Arquivo Semente
            </button>
            <button
              mat-flat-button
              extended
              (click)="navigateToCreatePage()"
              [disabled]="
                canCreateRequest() === false ||
                ((buttonLoading$ | async) ?? false) ||
                ((globalLoading$ | async) ?? false)
              "
            >
              @if ((buttonLoading$ | async) ?? false) {
                <mat-icon>hourglass_empty</mat-icon>
              } @else {
                <mat-icon>add</mat-icon>
              }
              Solicitar análise
            </button>
          </div>
        } @else {
          <!-- Cliente: Tudo na mesma linha -->
          <div class="filters-row client-layout">
            <app-datasafra-search
              (search)="handleSearch($event)"
            ></app-datasafra-search>

            <button
              mat-flat-button
              extended
              (click)="navigateToCreatePage()"
              [disabled]="
                canCreateRequest() === false ||
                ((buttonLoading$ | async) ?? false) ||
                ((globalLoading$ | async) ?? false)
              "
            >
              @if ((buttonLoading$ | async) ?? false) {
                <mat-icon>hourglass_empty</mat-icon>
              } @else {
                <mat-icon>add</mat-icon>
              }
              Solicitar análise
            </button>
          </div>
        }
      }

      @if (selectedTabIndex === 1 && userService.isGeoambiente) {
        <app-monitoring-filter
          (filterChange)="handleFilterChange($event)"
        ></app-monitoring-filter>
      }
    </div>
  </div>

  <mat-tab-group
    [(selectedIndex)]="selectedTabIndex"
    (selectedIndexChange)="onTabChange($event)"
    animationDuration="300ms"
    class="monitoring-tabs"
  >
    <mat-tab label="Solicitação">
      <div [style.display]="selectedTabIndex === 0 ? 'block' : 'none'">
        <app-requests-table
          [dataSource]="dataSource"
          [isLoading]="(gridLoading$ | async) ?? false"
          [length]="length"
          [config]="tableConfig"
          [actions]="tableActions"
          (sortChange)="onSortChange($event)"
          (pageChange)="onPageChange($event)"
          (rowToggle)="onRowToggle($event)"
          (viewAdminClick)="handleViewAdmin($event)"
          (refresh)="loadTabData()"
        >
          <ng-template #expandedDetailTemplate let-el>
            @let element = asTypedItem(el);
            <div class="requests-element-diagram">
              <div class="requests-detail-row">
                <span>
                  <b>Área total da solicitação (ha)</b>
                  {{ element["totalAreaHa"] ?? "-" }}
                </span>
              </div>
              <div class="requests-detail-row">
                <span>
                  <b>Nº de áreas de monitoramento:</b>
                  {{ element.totalAreaCount ?? "-" }}
                </span>
              </div>
              <div class="requests-detail-row">
                <span>
                  <b>Status da solicitação:</b>
                  {{ element.status.description }}
                </span>
              </div>
              <div class="requests-detail-row">
                <span>
                  <b>Data do evento:</b>
                  {{ element.lastModifiedDate | date: "dd/MM/yyyy HH:mm:ss" }}
                </span>
              </div>
              @if (element.status.code === "FAILED") {
                <div class="requests-detail-row">
                  <span>
                    <b>Motivo do cancelamento:</b>
                    {{ element.error ?? "-" }}
                  </span>
                </div>
              }
            </div>
          </ng-template>
        </app-requests-table>
      </div>
    </mat-tab>

    <!-- Aba "Arquivos semente" - apenas para admins -->
    @if (userService.isGeoambiente) {
      <mat-tab label="Arquivos semente">
        <div [style.display]="selectedTabIndex === 1 ? 'block' : 'none'">
          <app-file-seed-table
            [dataSource]="fileSeedDataSource"
            [isLoading]="(gridLoading$ | async) ?? false"
            [length]="fileSeedLength"
            [config]="fileSeedTableConfig"
            [actions]="fileSeedTableActions"
            (sortChange)="onFileSeedSortChange($event)"
            (pageChange)="onFileSeedPageChange($event)"
            (refresh)="loadFileSeedData()"
          >
          </app-file-seed-table>
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</div>
